import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import { DeepPartial, CustomerEmployeesGroup } from "~/application/types";
import { Button } from "~/components/Button";
import { Container } from "~/components/Container";
import { DialogBody } from "~/components/Dialog";
import { Form } from "~/components/Form/Form";
import { FieldLabel, FormControl } from "~/components/FormControl";
import { FormDialog } from "~/components/FormDialog";
import { Col, Row } from "~/components/Grid";
import { TextInput } from "~/components/Input";
import { Spinner } from "~/components/Spinner";
import { Text } from "~/components/Text";

const customerEmployeesGroupSchema = yup.object().shape({
  description: yup.string().required("A descrição do grupo é obrigatória"),
});

type CustomerEmployeesGroupSchema = yup.InferType<typeof customerEmployeesGroupSchema>;

export interface CustomerEmployeesGroupDialogProps {
  isNew?: boolean;
  defaultData?: DeepPartial<CustomerEmployeesGroup>;
  onCloseClick?: () => void;
  onSubmit: (data: CustomerEmployeesGroup) => void;
}

export function CustomerEmployeesGroupDialog({
  isNew,
  defaultData,
  onCloseClick,
  onSubmit,
}: CustomerEmployeesGroupDialogProps) {
  const { control, formState, handleSubmit } = useForm<CustomerEmployeesGroupSchema>({
    defaultValues: defaultData,
    resolver: yupResolver(customerEmployeesGroupSchema),
  });

  return (
    <Container size="8" fixed>
      <Form onSubmit={handleSubmit((data) => onSubmit(data as CustomerEmployeesGroup))}>
        <FormDialog
          title={isNew ? "Novo grupo" : "Editar grupo"}
          negativeButton={
            <Button variant="tertiary" onClick={onCloseClick}>
              <Text>Cancelar</Text>
            </Button>
          }
          positiveButton={
            <Button disabled={formState.isSubmitting} type="submit">
              {formState.isSubmitting && (
                <Spinner
                  css={{
                    borderLeftColor: "$neutrals-white",
                    width: "$4",
                    height: "$4",
                    borderWidth: "2px",
                  }}
                />
              )}
              <Text>{isNew ? "Adicionar" : "Aplicar"}</Text>
            </Button>
          }
          onClickDismissButton={onCloseClick}
        >
          <DialogBody css={{ p: "$6", maxHeight: "70vh" }}>
            <Row gap="6">
              <Col sz="12">
                <FormControl name="description" control={control} required>
                  <FieldLabel>Descrição</FieldLabel>
                  <TextInput placeholder="Digite a descrição do grupo" />
                  {formState.errors.description && (
                    <Text variant="error-base" size="2" css={{ mt: "$2", fontWeight: "bold" }}>
                      {formState.errors.description.message}
                    </Text>
                  )}
                </FormControl>
              </Col>
            </Row>
          </DialogBody>
        </FormDialog>
      </Form>
    </Container>
  );
}
